import {
    CompleteMultipartUploadCommand,
    CreateMultipartUploadCommand,
    CreateMultipartUploadCommandInput,
    MultipartUpload,
    S3Client,
    UploadPartCommand,
} from '@aws-sdk/client-s3'
import { StreamingBlobPayloadInputTypes } from '@smithy/types'

import { getCredentials, REGION } from 'src/services/aws/credentials'

/* istanbul ignore next */
export const getS3Client = async (): Promise<S3Client> => {
    return new S3Client({
        region: REGION,
        credentials: await getCredentials(),
    })
}

export const multipartUpload = async (
    client: S3Client,
    file: StreamingBlobPayloadInputTypes,
    config: CreateMultipartUploadCommandInput
) => {
    const upload: MultipartUpload = await client.send(new CreateMultipartUploadCommand(config))
    const uploadPart = await client.send(
        new UploadPartCommand({
            ...config,
            UploadId: upload.UploadId,
            PartNumber: 1,
            Body: file,
        })
    )
    return await client.send(
        new CompleteMultipartUploadCommand({
            ...config,
            UploadId: upload.UploadId,
            MultipartUpload: {
                Parts: [
                    {
                        ETag: uploadPart.ETag,
                        PartNumber: 1,
                    },
                ],
            },
        })
    )
}
